import React from "react";
import "../../../../App.css";

function LoaderMain() {
  return (
    <div
      className="preloader loading"
      id="preloader-active"
      role="status"
      aria-live="polite"
    >
      <div className="preloader-loading">
        <span className="preloader-ring preloader-ring--outer"></span>
        <span className="preloader-ring preloader-ring--inner"></span>
        <span className="preloader-dot"></span>
      </div>
      <p className="preloader-label">Bringing Kerala&apos;s finest to you...</p>
    </div>
  );
}

export default LoaderMain;

